import { render, staticRenderFns } from "./tripleCotasking.vue?vue&type=template&id=de951c8e&scoped=true&"
import script from "./tripleCotasking.vue?vue&type=script&lang=js&"
export * from "./tripleCotasking.vue?vue&type=script&lang=js&"
import style0 from "./tripleCotasking.vue?vue&type=style&index=0&id=de951c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de951c8e",
  null
  
)

export default component.exports